import { Component, Input } from '@angular/core';
import { PoeModalService, TranslationService } from '@app/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, map, Observable, of } from 'rxjs';
import { MachineInfosService } from '../machine-infos/machine-infos.service';

@Component({
    selector: 'app-prompt-machine-number-modal',
    templateUrl: './prompt-machine-number-modal.component.html',
    styleUrls: ['./prompt-machine-number-modal.component.scss'],
    standalone: false
})
export class PromptMachineNumberModalComponent {
    @Input() title: string;
    @Input() bodyText: string;
    inpMachinenumber: string;
    loadsMachineData: boolean = false;

    constructor(
        private readonly machininfosService: MachineInfosService,
        public modal: NgbActiveModal,
        private readonly translateService: TranslationService,
        private readonly modalService: PoeModalService
    ) { }

    onEnter(): void {
        this.saveInput().subscribe();
    }

    exitModal(): void {
        this.saveInput().subscribe(success => {
            if (success) {
                this.modal.close(this.inpMachinenumber);
            }
        });
    }

    private saveInput(): Observable<boolean> {
        if (!this.inpMachinenumber) { // !'string' checks for null or empty
            return of(false);
        }

        this.inpMachinenumber = this.inpMachinenumber.replace('VBP', '').replace(/^0+/, '');

        this.loadsMachineData = true;
        return this.machininfosService.fetchMachineData(this.inpMachinenumber, 'de_AT').pipe(
            map(infos => {
                if (!infos.maktx || infos.detectedType !== 'serial') {
                    this.modalService.showInfoModal(
                        {
                            title: this.translateService.translateInstant('Invalid Input'),
                            message: this.translateService.translateInstant('NotAValideChassis-Nr'),
                            confirmText: this.translateService.translateInstant('Confirm')
                        }
                    );
                    return false;
                }
                this.loadsMachineData = false;
                return true;
            }), catchError(() => {
                this.loadsMachineData = false;
                this.modalService.showInfoModal({
                    title: this.translateService.translateInstant('Invalid Input'),
                    message: this.translateService.translateInstant('NotAValideChassis-Nr'),
                    confirmText: this.translateService.translateInstant('Confirm')
                });
                return of(false);
            })
        );

    }

}
